import { serviceHost } from "../../common/const";
import ServiceRequest from "../../utils/service-request";

export const getAllQueries = async () => {
  try {
    let response = await ServiceRequest(
      "get",
      "json",
      serviceHost + "/query/getAllQuery"
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const saveQuery = async (queryData) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/query/saveQuery/",
      queryData
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const getQueryDetails = async (queryId) => {
  try {
    let response = await ServiceRequest(
      "get",
      "json",
      serviceHost + "/query/getQueryDetail/" + queryId
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const saveAnswer = async (ansData) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/query/saveAnswer/",
      ansData
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
export const getQueryByGroup = async (group) => {
  try {
    let response = await ServiceRequest(
      "get",
      "json",
      serviceHost + "/query/subject/" + group
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
